import { render } from "./SauSage.vue?vue&type=template&id=5e4d0dcc"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/SauSage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e4d0dcc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e4d0dcc', __exports__)) {
    api.reload('5e4d0dcc', __exports__)
  }
  
  module.hot.accept("./SauSage.vue?vue&type=template&id=5e4d0dcc", () => {
    api.rerender('5e4d0dcc', render)
  })

}


export default __exports__